module.exports = __webpack_public_path__ + "media/luxury-2026/black-tub-960-a1aa2b54.jpg";